<!--
 * @Author: baiwei
 * @Date: 2020-03-25 11:19:35
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-11-22 14:15:07
 * @Description: 描述
 * @Copyright: Cloud-Star. Co. Ltd. All rights reserved.
 -->
<template>
    <div style="height: 100%;"
         class="module">
        <helpinfo :helpData="helpData" />
        <div class="module-container">
            <div class="hint">
                <i class="icon-prompt-1-o"></i>
                <div class="content-tip">
                    <p>{{$t('帐单出账会有延迟，预付费资源：资源创建成功几分钟后出帐；后付费资源：每小时整点生成账单明细数据，次月生成账单周期数据。')}}</p>
                    <p>{{$t('结算金额保留2位小数，不足0.01按0.01计算。')}}</p>
                </div>
            </div>
            <Tabs v-model="curTab"
                  name="bills"
                  type="card"
                  :animated="false"
                  class="bill-pack">
                <TabPane :label="$t('账单周期')"
                         name="billCycle"
                         v-if="hasPermission('CC0303')"
                         tab="bills">
                    <billCycle ref="billcycle"
                               v-if="curTab === 'billCycle'"
                               :statusMap="statusMap"
                               @toggleExport="toggleExport"
                               @toggleTask="toggleTask" />
                </TabPane>
                <TabPane :label="$t('账单明细')"
                         name="billDetail"
                         v-if="hasPermission('CC0304')"
                         tab="bills">
                    <Product ref="product"
                             v-if="curTab === 'billDetail'"
                             :statusMap="statusMap"
                             @toggleExport="toggleExport"
                             @toggleTask="toggleTask" />
                </TabPane>
            </Tabs>
            <exportModal :visible="showExportModal"
                         :type="curTab"
                         :subType="subType"
                         :exportParams="exportParams"
                         @cancel="cancelExport" />
            <downloadTaskModal :visible="showTaskModal"
                               :type="curTab"
                               @cancel="toggleTask" />
        </div>
    </div>
</template>

<script>
import helpinfo from '@/views/components/basic/helpinfo'
import Product from './product'
import billCycle from './billcycle'
import exportModal from '@/views/console/bills/components/exportmodal'
import downloadTaskModal from '@/views/console/bills/components/downloadtaskmodal'
// import Resource from './resource'
// import API from '@/service/api'
export default {
    name: 'bill',
    components: {
        helpinfo,
        Product,
        billCycle,
        exportModal,
        downloadTaskModal
        // Resource
    },
    data () {
        const isBssAdmin = this.$store.state.user.currentUser.isBssAdmin
        return {
            helpData: {
                modelName: this.$t(isBssAdmin ? '账单管理' : '我的账单')
            },
            curTab: 'billCycle',
            subType: 'cycle',
            showExportModal: false,
            showTaskModal: false,
            exportParams: {},
            statusMap: Object.freeze({
                none: '未开票',
                pending: '开票中',
                done: '已开票',
                rejected: '驳回',
                null: '未开票'
            })
        }
    },
    methods: {
        toggleTask () {
            this.showTaskModal = !this.showTaskModal
        },
        toggleExport (params, subType) {
            const paramList = {}
            for (const key in params) {
                paramList[key] = params[key] || ''
            }
            this.subType = subType
            this.exportParams = paramList || {}
            this.showExportModal = true
        },
        cancelExport () {
            this.subType = ''
            this.exportParams = {}
            this.showExportModal = false
        }
    }
}
</script>
<style lang="less">
.bill-pack {
    .ivu-tabs-content {
        height: calc(~'100% - 55px');
    }
}
</style>
<style lang="less" scoped>
.content-tip {
    display: inline-block;
}
.bill-pack {
    padding: 0px;
}
</style>
